import { defineMessages } from 'react-intl-next';

export default defineMessages({
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.link.unlink.button.link.button.text',
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.link.unlink.button.unlink.button.text',
    },
    unlinkModalTitle: {
        defaultMessage: `Unlink {value}?`,
        description: 'Unlink project modal title',
        id: 'projects.link.unlink.button.unlink.modal.title.non-final',
    },
    unlinkModalDesc: {
        defaultMessage: `Unlinking this project will remove it’s resources from any ‘Topics’ that are created in this help center. This change is irreversible.`,
        description: 'Unlink project modal description',
        id: 'projects.link.unlink.button.unlink.modal.description.non-final',
    },
    unlinkModalConfirmButton: {
        defaultMessage: 'Confirm',
        description: 'Unlink project modal confirm button',
        id: 'projects.link.unlink.button.unlink.modal.confirm.button.non-final',
    },
    unlinkModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Unlink project modal cancel button',
        id: 'projects.link.unlink.button.unlink.modal.cancel.button.non-final',
    },
    unlinkSuccessTitle: {
        defaultMessage: `{value} unlinked successfully`,
        description: 'Unlink project flag success title',
        id: 'projects.link.unlink.button.unlink.flag.success.title.non-final',
    },
    linkSuccessTitle: {
        defaultMessage: `Project linked successfully`,
        description: 'Link project flag success title',
        id: 'projects.link.unlink.button.link.flag.success.title.non-final',
    },
    unlinkErrorTitle: {
        defaultMessage: 'Unlinking failed',
        description: 'Unlink project flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title.non-final',
    },
    linkErrorTitle: {
        defaultMessage: 'Linking failed',
        description: 'Link project flag error title',
        id: 'projects.link.unlink.button.link.flag.error.title.non-final',
    },
    unlinkErrorDescription: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Unlink project flag error description',
        id: 'projects.link.unlink.button.unlink.flag.error.description.non-final',
    },
    lastProjectUnlink: {
        defaultMessage:
            'You cannot unlink the only project linked to your help center. Your help center must contain at least one project',
        description: 'Last project unlink project dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content.non-final',
    },
});
